import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import store from "./store/index";
import {
  Mainnet,
  BSC,
  BSCTestnet,
  AvalancheTestnet,
  DAppProvider,
} from "@usedapp/core";

const config = {
  readOnlyChainIds: [
    BSCTestnet.chainId,
    Mainnet.chainId,
    AvalancheTestnet.chainId,
  ],
  readOnlyUrls: {},
  networks: [BSC, BSCTestnet, Mainnet, AvalancheTestnet],
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <DAppProvider config={config}>
        <App />
      </DAppProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
